import { gql } from "@apollo/client";

export default gql`
  mutation InviteGovernmentsToGroup($groupId: ObjectId!, $governmentIds: [ObjectId!]!) {
    inviteGovernmentsToGroup(groupId: $groupId, governmentIds: $governmentIds) {
      _id
      government {
        _id
        logo
        name
        slug
      }
      createdAt
    }
  }
`;
